module.exports = __webpack_public_path__ + "static/media/logo.02d30065.svg";